module.exports = __webpack_public_path__ + "img/male-teenager-hand.d79d495a.svg";